import Lottie from "lottie-react";

import loaderAnimationJson from "@/assets/svg-animations/loader.json";

import "./loading-screen.scss";

type LoadingScreenProps = {
  blur?: boolean;
};

const LoadingScreen = (props: LoadingScreenProps) => {
  const { blur } = props;

  return (
    <div className={`loading-screen${blur ? " loading-screen--blur" : ""}`}>
      <Lottie animationData={loaderAnimationJson} loop={true} />
    </div>
  );
};

export { LoadingScreen };
